import { render, staticRenderFns } from "./PickingBins.vue?vue&type=template&id=68f741f4"
import script from "./PickingBins.vue?vue&type=script&lang=js"
export * from "./PickingBins.vue?vue&type=script&lang=js"
import style0 from "./PickingBins.vue?vue&type=style&index=0&id=68f741f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports